import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { LeaderboardDTO } from "../../schema/Gamification/Leaderboard/LeaderboardDTO";
import { LeaderboardFiltersDTO } from "../../schema/Gamification/Leaderboard/LeaderboardFiltersDTO";

@Injectable({
    providedIn: "root"
})
export class ApiLeaderboardsService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.gamification.url}/api/v1/Leaderboards`;
    }

    Get(filter: LeaderboardFiltersDTO): Observable<GetDataDTO<LeaderboardDTO>> {
        let params = new HttpParams()
            .set("skip", filter.skip.toString())
            .set("take", filter.take.toString())
            .set("sortOrder", filter.sortOrder.toString())
            .set("orderBy", filter.orderBy.toString());

        if (filter.showGroups != null) params = params.set("showGroups", filter.showGroups.toString());
        if (filter.showUsers != null) params = params.set("showUsers", filter.showUsers.toString());
        if (filter.rankingId) params = params.set("rankingId", filter.rankingId);
        if (filter.userId) params = params.set("userId", filter.userId);
        if (filter.userGroupIds?.length > 0) filter.userGroupIds.forEach((id) => params.append("userGroupIds", id));

        return this.httpClient.get<GetDataDTO<LeaderboardDTO>>(this.relativePath, { params: params });
    }
}
